var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-row", [
    _c(
      "div",
      { staticClass: "nav-tabs-wrapper coupled bb-0 mb-4" },
      [
        _c("scrollable-container", [
          _c(
            "ul",
            { staticClass: "nav nav-tabs scroll-container" },
            _vm._l(_vm.pages, function (ref) {
              var route = ref.route
              var label = ref.label
              return _c("router-link", {
                key: route.name,
                attrs: { id: route.name, to: route, exact: "", custom: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var navigate = ref.navigate
                        var isExactActive = ref.isExactActive
                        return [
                          _c(
                            "li",
                            {
                              staticClass: "nav-item",
                              class: {
                                "navbar-active": isExactActive,
                              },
                              attrs: { role: "link" },
                              on: {
                                click: navigate,
                                keypress: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return navigate.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "nav-link grey-text text-darken-3 clickable",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(label) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }